import { useQuery } from '@apollo/client/react';

import { compareLwcDetails } from '../../helpers/getAllLeadData';
import {
  LwcDetailsForBrokerage_odProtosListingsServicesListwithcertaintyproduct_getLwcDetailsForBrokerage_lwcDetails as BrokerageLwcDetails,
  LwcDetailsForBrokerage,
  LwcDetailsForBrokerageVariables,
} from './queries/__generated__/LwcDetailsForBrokerage';
import { LWC_DETAILS_FOR_BROKERAGE_QUERY } from './queries/BrokerageLwcDetails';

const sortBrokerageLwcDetailsByState = (lwcDetails: BrokerageLwcDetails[]) => {
  // Get an error locally sorting in place
  return [...lwcDetails].sort(compareLwcDetails);
};

export const useLwcDetailsForBrokerage = (agentCustomerUuid?: string | null) => {
  const { data, loading, error } = useQuery<
    LwcDetailsForBrokerage,
    LwcDetailsForBrokerageVariables
  >(LWC_DETAILS_FOR_BROKERAGE_QUERY, {
    context: {
      clientName: 'athena',
    },
    skip: !agentCustomerUuid || agentCustomerUuid === '',
    variables: { agentCustomerUuid: agentCustomerUuid ?? '' },
    fetchPolicy: 'cache-first',
  });

  const lwcDetails: BrokerageLwcDetails[] =
    data?.odProtosListingsServicesListwithcertaintyproduct?.getLwcDetailsForBrokerage?.lwcDetails ||
    [];

  const sortedLwcDetails = sortBrokerageLwcDetailsByState(lwcDetails);

  return { data, details: sortedLwcDetails, loading, error };
};
